import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Articulo.css'

import defaultBg from '../../assets/img/defaultBg.png'

import axios from 'axios';
import atrasIcon from '../../assets/icons/atras-icon.svg'
import { useParams } from 'react-router-dom';



function Articulo({ titulo, fecha, imagen, articulos }) {

    let navigate = useNavigate()
    const { id } = useParams();
    const location = useLocation();
    const { pathname } = useLocation();
    // let inmueble = []
    const [articulo, setArticulo] = useState([]);

    useEffect(() => {




        axios.get(`${process.env.REACT_APP_URL_SERVER}/blog/${id}`, { params: { _id: id } }).then(async response => {
            // console.log(response.data[0])


            setArticulo(response.data[0])


            // console.log(pathname)
            // //console.log('estoy recibiendo datos')
            // setInmueble(response.data[0])
        }).catch(() => {
            console.log('Error')
        })

    }, [])


    return (
        <div className='articulo-container'>
            <button className='generic-btn' style={{ paddingInline: '15px', marginTop: '-57px', marginBottom: '57px' }} onClick={() => navigate(`/blog/`)}><img height={20} src={atrasIcon} alt="icono volver atrás" /></button>

            <h1 className='articulo-titulo'>{articulo.titulo}</h1>
            <h5 className='articulo-fecha'>{new Date(articulo.fechaSubido).toLocaleDateString()}</h5>
            <div className='articulo-img-wrapper'>
                <img className='articulo-img' src={articulo.imagen ? `${process.env.REACT_APP_DIR_SERVER}/${articulo.imagen.url}` : defaultBg} alt="Imagen artículo" />
            </div>
            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>{articulo.articulo}</div>
        </div>
    );
}

export default Articulo;